<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4">
                            <h4 class="page-title">{{ $t('string.msg.company.list.label.title') }}</h4>
                        </h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{ $t('str.total') }}</h4>
                        <h4 class="text-center" style="color: grey">{{ items.length }}</h4>
                    </div>
                </div>

                <p class="sub-header">
                    {{ $t('string.msg.companies.search.description') }}
                </p>

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="inputAddress" class="col-form-label">
                                {{ $t('string.msg.company.label.type') }}
                            </label>
                            <select v-model="filters.typeService" class="form-control" @change="onChange()">
                                <option value="" selected>{{ $t('string.msg.element.select.selectitem') }}</option>
                                <option value="PART_SUPPLIER">{{ $t('string.msg.company.label.type.autoparts') }}</option>
                                <option value="CERTIFIER">{{ $t('string.msg.company.label.type.certifier') }}</option>
                                <option value="SERVICE_PROVIDER" selected>{{ $t('string.msg.company.label.type.serviceprovider') }}</option>
                                <option value="FLEET_DRIVER" selected>{{ $t('string.msg.company.label.type.fleetdriver') }}</option>
                                <option value="GAS_STATION" selected>{{ $t('string.msg.user.gasstation.label.title') }}</option>
                            </select>
                        </div>

                        <div class="form-group col-md-4">
                            <label class="col-form-label">
                                <code class="highlighter-rouge">*</code>
                                {{ $t('string.msg.company.label.status') }}
                            </label>
                            <select v-model="filters.status" class="form-control">
                                <option :value="null" selected>{{ $t('string.msg.element.select.selectitem') }}</option>
                                <option value="ACTIVE">{{ $t('string.msg.active') }}</option>
                                <option value="ARCHIVED">{{ $t('string.msg.archived') }}</option>
                            </select>
                        </div>

                        <div class="form-group col-md-4">
                            <label for="inputAddress" class="col-form-label"> Razão Social, Nome Fantasia ou CNPJ </label>
                            <!--<input type="text" v-model="filters.name" class="form-control" @input="onChangeName($event)">-->
                            <autocomplete :search="onChangeName" :get-result-value="getResultValue" @submit="submitFilter" debounceTime="500"></autocomplete>
                        </div>
                    </div>

                    <br />
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-20">{{ $t('string.msg.form.btn.search') }}</button>
                        <div v-if="items && items.length > 0">
                            <download-excel v-if="filters.typeService == ''" class="btn btn-primary" :fetch="fetchData" :fields="json_fields" :meta="json_meta" type="csv" name="associados-geral.xls">
                                Download CSV
                            </download-excel>
                            <download-excel
                                v-else-if="filters.typeService == 'PART_SUPPLIER'"
                                class="btn btn-primary"
                                :fetch="fetchData"
                                :fields="json_fields"
                                :meta="json_meta"
                                type="csv"
                                name="auto-peças.xls"
                            >
                                Download CSV
                            </download-excel>
                            <download-excel
                                v-else-if="filters.typeService == 'CERTIFIER'"
                                class="btn btn-primary"
                                :fetch="fetchData"
                                :fields="json_fields"
                                :meta="json_meta"
                                type="csv"
                                name="certificadoras.xls"
                            >
                                Download CSV
                            </download-excel>
                            <download-excel
                                v-else-if="filters.typeService == 'SERVICE_PROVIDER'"
                                class="btn btn-primary"
                                :fetch="fetchData"
                                :fields="json_fields"
                                :meta="json_meta"
                                type="csv"
                                name="prestadores-serviço.xls"
                            >
                                Download CSV
                            </download-excel>
                            <download-excel v-else-if="filters.typeService == 'FLEET_DRIVER'" class="btn btn-primary" :fetch="fetchData" :fields="json_fields" :meta="json_meta" type="csv" name="frotistas.xls">
                                Download CSV
                            </download-excel>
                        </div>
                    </div>
                </form>

                <div class="pb-0 pt-3 cursor-pointer">
                    <jw-pagination :items="items" @changePage="onChangePage" :labels="customLabels"></jw-pagination>
                </div>
                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{ $t('string.msg.company.label.fantasyName') }}</th>
                                <th class="border-top-0">{{ $t('string.msg.company.label.document') }}</th>
                                <th class="border-top-0">{{ $t('string.msg.company.label.type') }}</th>
                                <th class="border-top-0">{{ $t('string.msg.company.label.main.email') }}</th>
                                <th class="border-top-0">{{ $t('string.msg.company.label.primaryPhone') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer" @click="selectItem(item)">
                                <td v-if="item.socialName">
                                    <span>
                                        {{ toUpperCase(item.socialName) }}
                                    </span>
                                </td>
                                <td v-if="item.document">
                                    <input type="tel" readonly v-mask="['###.###.###-##', '##.###.###/####-##']" class="form-control reset-input" :value="item.document" />
                                </td>
                                <td>
                                    <p>
                                        {{ item.typeService.includes('SERVICE_PROVIDER') ? $t('string.msg.company.label.type.serviceprovider') : '' }}
                                    </p>
                                    <p>
                                        {{ item.typeService.includes('PART_SUPPLIER') ? $t('string.msg.company.label.type.autoparts') : '' }}
                                    </p>
                                    <p>
                                        {{ item.typeService.includes('CERTIFIER') ? $t('string.msg.company.label.type.certifier') : '' }}
                                    </p>
                                    <p>
                                        {{ item.typeService.includes('FLEET_DRIVER') ? $t('string.msg.company.label.type.fleetdriver') : '' }}
                                    </p>
                                    <p>
                                        {{ item.typeService.includes('GAS_STATION') ? $t('string.msg.user.gasstation.label.title') : '' }}
                                    </p>
                                </td>
                                <td v-if="item.email">
                                    <span>
                                        {{ item.email }}
                                    </span>
                                </td>
                                <td v-if="item.primaryPhone">
                                    <span>
                                        {{ item.primaryPhone }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <Toast :title="titleToast" :message="messageToast" />
    </div>
</template>

<script>
import Controller from './CrtListCompanies'
import Spinner from '../../../components/layout/Spinner'
import Toast from '../../../components/layout/Toast'
import JsonExcel from 'vue-json-excel'
import JwPagination from 'jw-vue-pagination'
Vue.component('jw-pagination', JwPagination)
Vue.component('downloadExcel', JsonExcel)
import Vue from 'vue'
Vue.prototype.$eventHub = new Vue()
export default {
    name: 'ListCompanies',
    props: ['valuekey'],
    watch: {
        valuekey() {},
    },
    components: {
        Spinner,
        Toast,
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            PageNumbers: 1,
            items: [],
            pageOfItems: [],
            companiesSuggest: null,
            filters: {
                typeService: '',
                name: '',
                status: 'ACTIVE',
                isHideDetailsManufecturerFamily: true,
                isHideDetailsCertifies: true,
                isHideDetailsServiceFamilies: true,
                skip: 0,
                limit: 999999,
            },
            json_fields: {
                'Nome Fantasia': 'fantasyName',
                Telefone: 'primaryPhone',
                Email: 'email',
                CNPJ: 'document',
            },
            json_data: [
                {
                    companyUser: {
                        company: {
                            fantasyName: null,
                            primaryPhone: null,
                            email: null,
                            document: null,
                        },
                    },
                },
            ],
            json_meta: [
                [
                    {
                        key: 'charset',
                        value: 'utf-8',
                    },
                ],
            ],
            customLabels: {
                first: 'Primeira',
                last: 'Último',
                previous: 'Anterior',
                next: 'Próxima',
            },
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this)
        let state = this
        this.$eventHub.$on('refreshList', function () {
            state.filter()
        })
    },
    mounted() {},
}
</script>

<style>
</style>
